import React from 'react';

export default function Contact(){
    return(
        <div  id='contactpage'>
            <div className='commonbox contact'>
                <h1 className='boxheadings'>Let's connect! <br></br> Reach me at any of these handles.</h1>
                <div className='links'>
                    <a className='email' href="mailto:rishikeshsarangan@gmail.com">Email</a><br></br><br></br>
                    <a className='insta' href="https://www.instagram.com/its.rishikesh/">Instagram</a><br></br><br></br>
                    <a className='linkedin' href="https://www.linkedin.com/in/rishikesh-sarangan">LinkedIn</a>
                </div>
            </div>
        </div>
        
    );
}